import React, { Component } from "react";
import $ from "jquery";
import "./App.css";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import About from "./Components/About";
import Projects from "./Components/Projects";
//import Contact from "./Components/Contact";
//import Portfolio from "./Components/Portfolio";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      foo: "bar",
      resumeData: {}
    };

    //ReactGA.initialize("G-WTF8PF31LX");
    //ReactGA.pageview(window.location.pathname);
  }

  getResumeData() {
    $.ajax({
      url: "./resumeData.json",
      dataType: "json",
      cache: false,
      success: function(data) {
        this.setState({ resumeData: data });
      }.bind(this),
      error: function(xhr, status, err) {
        console.log(err);
        alert(err);
      }
    });
  }

  componentDidMount() {
    this.getResumeData();
  }

  render() {
    return (
      <div className="App">
        <Header data={this.state.resumeData.main} />
        <Projects data={this.state.resumeData.projects} />
        <About data={this.state.resumeData.main} />
        <Footer data={this.state.resumeData.main} />
      </div>
      );
      //<Contact data={this.state.resumeData.main} />
      //<Portfolio data={this.state.resumeData.portfolio} />
  }
}

export default App;
